import { c as _c } from "react/compiler-runtime";
import React from 'react';
import useProductListingPageContext from 'data-hooks/useProductListingPageContext';
import LabeledSelectBox from 'components/consumer/LabeledSelectBox';
import { SORT_BY_OPTIONS } from 'commons/constants';
import MobileOnly from 'components/consumer/MobileOnly';
import TabletAndDesktopOnly from 'components/consumer/TabletAndDesktopOnly';
const ProductListingSortBy = () => {
  const $ = _c(15);
  const {
    setSortOrder,
    sortOrder,
    sortByOptions
  } = useProductListingPageContext();
  const options = sortByOptions || SORT_BY_OPTIONS;
  let t0;
  if ($[0] !== setSortOrder) {
    t0 = e => {
      const updatedValue = e?.target?.value;
      setSortOrder(updatedValue);
    };
    $[0] = setSortOrder;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== options || $[3] !== sortOrder || $[4] !== t0) {
    t1 = <MobileOnly><LabeledSelectBox className="md:hidden" label="Sort by" options={options} value={sortOrder} showBlankOption={false} showSingleLineLabelOverlay={true} noMargin={true} size="xs" onChange={t0} /></MobileOnly>;
    $[2] = options;
    $[3] = sortOrder;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== setSortOrder) {
    t2 = e_0 => {
      const updatedValue_0 = e_0?.target?.value;
      setSortOrder(updatedValue_0);
    };
    $[6] = setSortOrder;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== options || $[9] !== sortOrder || $[10] !== t2) {
    t3 = <TabletAndDesktopOnly><LabeledSelectBox className="max-[767px]:hidden" label="Sort by" options={options} value={sortOrder} showBlankOption={false} showSingleLineLabelOverlay={true} noMargin={true} size="sm" onChange={t2} /></TabletAndDesktopOnly>;
    $[8] = options;
    $[9] = sortOrder;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t1 || $[13] !== t3) {
    t4 = <div className="max-w-[215px] md:min-w-[16rem]">{t1}{t3}</div>;
    $[12] = t1;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};
export default ProductListingSortBy;